module.exports = __webpack_public_path__ + "static/media/clock-dark.7b4ebdf2.svg";